function extractUniversalFAQ() {
  const container = document.querySelector('.article-template-inner, .article-template-content, .article-template__content');
  if (!container) return [];

  const elements = Array.from(container.querySelectorAll('p, li, h2, h3, h4'));
  const faqList = [];
  const seenQuestions = new Set();
  
  let currentPair = null;
  let isCollectingAnswer = false;
  let hasReachedFAQSection = false;

const qRegex = /^\s*Q\d*[\.：:\s]\s*/i;
const aRegex = /^\s*A\d*[\.：:\s]\s*/i;
  const faqAnchorRegex = /(FAQ|FAQs|Frequently\s+asked\s+questions)/i;

  elements.forEach(el => {
    let tagName = el.tagName.toLowerCase();
    
   
    if (!hasReachedFAQSection && tagName === 'h2' && faqAnchorRegex.test(el.innerText)) {
      hasReachedFAQSection = true;
      return;
    }
    if (!hasReachedFAQSection) return;

   
    let rawHtml = el.innerHTML.trim();
 
    let lines = rawHtml.split(/<br\s*\/?>/i).map(l => l.trim()).filter(l => l);

    lines.forEach(line => {

      let tempDiv = document.createElement('div');
      tempDiv.innerHTML = line;
      let plainText = tempDiv.textContent.trim();

      if (!plainText) return;

     
      if (qRegex.test(plainText)) {
        isCollectingAnswer = false;
        let question = plainText.replace(qRegex, '').trim();
        if (question && !seenQuestions.has(question)) {
          currentPair = { q: question, a: "" };
          faqList.push(currentPair);
          seenQuestions.add(question);
        }
        return;
      }


      if (aRegex.test(plainText)) {
        isCollectingAnswer = true;
        
        let answerHtml = line.replace(/^(<[^>]+>)*\s*A\d*[:：]\s*/i, (match, p1) => {
          
            return p1 ? p1 : ""; 
        });
        
        if (currentPair) {
          currentPair.a = answerHtml;
        }
        return;
      }

    
      if (isCollectingAnswer && currentPair) {
        currentPair.a += (currentPair.a ? "<br>" : "") + line;
      }
    });
  });

  return faqList.filter(item => item.q && item.a);
}

function injectFAQ(data) {
  if (data.length === 0) return;
  
  const oldScript = document.getElementById('dynamic-faq-json');
  if (oldScript) oldScript.remove();

  const script = document.createElement('script');
  script.id = 'dynamic-faq-json';
  script.type = 'application/ld+json';


  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": data.map(item => ({
      "@type": "Question",
      "name": item.q, 
      "acceptedAnswer": { 
        "@type": "Answer", 
        "text": item.a 
      }
    }))
  };

  script.text = JSON.stringify(jsonLd);
  document.head.appendChild(script);
  

}


injectFAQ(extractUniversalFAQ()); 